/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  PaginatedProgramList,
  PaginatedProgramTypeList,
  PatchedProgramRequest,
  Program,
  ProgramRequest,
  ProgramType,
  ProgramsListParams,
  ProgramsTypesListParams
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsList = (
    params?: ProgramsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedProgramList>>,) => {
      return apiV2<PaginatedProgramList>(
      {url: `/programs/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsCreate = (
    programRequest: ProgramRequest,
 options?: SecondParameter<typeof apiV2<Program>>,) => {
      return apiV2<Program>(
      {url: `/programs/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: programRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<Program>>,) => {
      return apiV2<Program>(
      {url: `/programs/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsUpdate = (
    id: string,
    programRequest: ProgramRequest,
 options?: SecondParameter<typeof apiV2<Program>>,) => {
      return apiV2<Program>(
      {url: `/programs/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: programRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsPartialUpdate = (
    id: string,
    patchedProgramRequest?: PatchedProgramRequest,
 options?: SecondParameter<typeof apiV2<Program>>,) => {
      return apiV2<Program>(
      {url: `/programs/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProgramRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const programsDestroy = (
    id: string,
 options?: SecondParameter<typeof apiV2<void>>,) => {
      return apiV2<void>(
      {url: `/programs/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * A view mixin for V2 that ensures JSON data is rendered and parsed using camelCase.
 */
export const programsTypesList = (
    params?: ProgramsTypesListParams,
 options?: SecondParameter<typeof apiV2<PaginatedProgramTypeList>>,) => {
      return apiV2<PaginatedProgramTypeList>(
      {url: `/programs/types/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A view mixin for V2 that ensures JSON data is rendered and parsed using camelCase.
 */
export const programsTypesRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<ProgramType>>,) => {
      return apiV2<ProgramType>(
      {url: `/programs/types/${id}/`, method: 'GET'
    },
      options);
    }
  export type ProgramsListResult = NonNullable<Awaited<ReturnType<typeof programsList>>>
export type ProgramsCreateResult = NonNullable<Awaited<ReturnType<typeof programsCreate>>>
export type ProgramsRetrieveResult = NonNullable<Awaited<ReturnType<typeof programsRetrieve>>>
export type ProgramsUpdateResult = NonNullable<Awaited<ReturnType<typeof programsUpdate>>>
export type ProgramsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof programsPartialUpdate>>>
export type ProgramsDestroyResult = NonNullable<Awaited<ReturnType<typeof programsDestroy>>>
export type ProgramsTypesListResult = NonNullable<Awaited<ReturnType<typeof programsTypesList>>>
export type ProgramsTypesRetrieveResult = NonNullable<Awaited<ReturnType<typeof programsTypesRetrieve>>>
